import { createContext, useContext, useMemo, useState } from 'react';

const SettingsContext = createContext(null);

const DEFAULT_CALENDAR_SETTINGS = {
  workWeekOnly: true,
  timeFormat: '24h',
  coreStart: 8,
  coreEnd: 16
};

const DEFAULT_CRM_SETTINGS = {
  enableScoreboard: true
};

export const SettingsProvider = ({ children }) => {
  const [calendarSettings, setCalendarSettings] = useState(DEFAULT_CALENDAR_SETTINGS);
  const [crmSettings, setCrmSettings] = useState(DEFAULT_CRM_SETTINGS);

  const updateCalendarSettings = changes => {
    setCalendarSettings(currentSettings => ({
      ...currentSettings,
      ...changes
    }));
  };

  const updateCrmSettings = changes => {
    setCrmSettings(currentSettings => ({
      ...currentSettings,
      ...changes
    }));
  };

  const value = useMemo(
    () => ({
      calendarSettings,
      updateCalendarSettings,
      crmSettings,
      updateCrmSettings
    }),
    [calendarSettings, crmSettings]
  );

  return (
    <SettingsContext.Provider value={value}>
      {children}
    </SettingsContext.Provider>
  );
};

export const useSettings = () => {
  const context = useContext(SettingsContext);

  if (!context) {
    throw new Error('useSettings must be used within a SettingsProvider');
  }

  return context;
};